function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("style", null, ".lights-icon{fill:url(#lights);}"), /*#__PURE__*/React.createElement("radialGradient", {
  id: "lights",
  x1: 35,
  y1: 8.1,
  x2: 35,
  y2: 62.1,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#038FC7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#68C34F"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M256.53,460.65A45.49,45.49,0,0,1,211.06,416h0a45.55,45.55,0,0,1,44.66-46.32h.84a45.5,45.5,0,0,1,.83,91Zm0-81h-.66a35.54,35.54,0,0,0-34.84,36.15h0a35.5,35.5,0,1,0,35.5-36.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M72.78,168.77a5,5,0,0,1-5-5L67.62,146a14.36,14.36,0,0,1,3.44-9.58,12.37,12.37,0,0,1,9.29-4.28l16.55-.23H97c7.22,0,12.88,6,12.93,13.67l.16,17.83a5,5,0,0,1-5,5h0a5,5,0,0,1-5-4.95l-.16-17.84c0-2.14-1.26-3.75-2.9-3.75h0l-16.54.24a2.43,2.43,0,0,0-1.88.87,4.43,4.43,0,0,0-1,2.91l.16,17.83a5,5,0,0,1-5,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M74.78,119.45c-16.25,0-25.77-.44-26-.46a5,5,0,0,1,.48-10c.66,0,67.19,3.1,151.07-7.37,49.17-6.14,94.6-15.66,135-28.3C385.65,57.59,428.28,37,462,12A5,5,0,1,1,468,20c-34.66,25.65-78.32,46.81-129.76,62.89-41,12.82-87,22.47-136.84,28.68A1048.1,1048.1,0,0,1,74.78,119.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M89.5,247A45.5,45.5,0,1,1,135,201.5,45.55,45.55,0,0,1,89.5,247Zm0-81A35.5,35.5,0,1,0,125,201.5,35.55,35.55,0,0,0,89.5,166Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M89,142a5,5,0,0,1-5-5V116a5,5,0,0,1,10,0v21A5,5,0,0,1,89,142Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M236.24,155.32a5,5,0,0,1-4.93-4.2l-2.88-17.6c-1.23-7.63,3.37-14.49,10.47-15.64l16.31-2.75a12.43,12.43,0,0,1,9.92,2.64,14.29,14.29,0,0,1,5,8.88L273,144.24a5,5,0,1,1-9.87,1.61l-2.87-17.6a4.28,4.28,0,0,0-1.44-2.69,2.53,2.53,0,0,0-2-.57l-16.31,2.76c-1.63.26-2.57,2.05-2.23,4.17l2.88,17.59a5,5,0,0,1-4.13,5.74A5.78,5.78,0,0,1,236.24,155.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M258.42,230.56a45.63,45.63,0,1,1,7-.54A45.1,45.1,0,0,1,258.42,230.56Zm.17-81a36.45,36.45,0,0,0-5.49.42,35.5,35.5,0,1,0,40.5,29.67h0a35.51,35.51,0,0,0-35-30.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M248.18,126.39a5,5,0,0,1-4.93-4.24l-3.2-20.76a5,5,0,1,1,9.88-1.52l3.2,20.75a5,5,0,0,1-4.95,5.77Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M390.78,116.11a5,5,0,0,1-4.61-3.06l-6.92-16.44a14.3,14.3,0,0,1-.46-10.16,12.32,12.32,0,0,1,7-7.49L401,72.46a12.41,12.41,0,0,1,10.26.24,14.26,14.26,0,0,1,7,7.45l6.92,16.43a5,5,0,1,1-9.22,3.88L409,84a4.33,4.33,0,0,0-2-2.28,2.51,2.51,0,0,0-2.09-.08l-15.22,6.51a2.41,2.41,0,0,0-1.4,1.51,4.33,4.33,0,0,0,.22,3.06l6.91,16.43a5,5,0,0,1-2.67,6.55A4.9,4.9,0,0,1,390.78,116.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M420.57,185.19a45.51,45.51,0,1,1,42.09-62.81h0a45.56,45.56,0,0,1-42.09,62.81Zm0-81a35.5,35.5,0,1,0,32.88,22A35.42,35.42,0,0,0,420.53,104.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M395.61,85.19A5,5,0,0,1,391,82.08l-8-19.42a5,5,0,1,1,9.25-3.8l8,19.43a5,5,0,0,1-2.72,6.52A4.92,4.92,0,0,1,395.61,85.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M404.05,372.67a5,5,0,0,1-4.93-4.19l-2.89-17.6c-1.26-7.61,3.34-14.5,10.48-15.68l16.4-2.6a12.3,12.3,0,0,1,9.85,2.64,14.28,14.28,0,0,1,5,8.85l2.89,17.6a5,5,0,1,1-9.87,1.62l-2.88-17.6a4.35,4.35,0,0,0-1.44-2.69,2.41,2.41,0,0,0-2-.55l-16.4,2.6c-1.6.27-2.56,2.07-2.21,4.18L409,366.86a5,5,0,0,1-4.13,5.74A4.43,4.43,0,0,1,404.05,372.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M425.88,448a45.51,45.51,0,1,1,7.78-.67A44.93,44.93,0,0,1,425.88,448Zm0-81a35.92,35.92,0,0,0-6.08.52,35.51,35.51,0,1,0,6.08-.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M415.39,343.89a5,5,0,0,1-4.93-4.15l-3.58-20.69a5,5,0,0,1,9.86-1.71l3.58,20.7a5,5,0,0,1-4.08,5.78A4.88,4.88,0,0,1,415.39,343.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M240.28,382.36a5,5,0,0,1-5-4.95l-.17-17.83c-.09-7.71,5.51-13.82,12.74-13.9l16.61-.07h.14c7.09,0,12.72,5.95,12.81,13.62l.17,17.84a5,5,0,0,1-5,5.05h0a5,5,0,0,1-5-4.95l-.17-17.84c0-2.13-1.28-3.75-2.87-3.72l-16.62.07c-1.61,0-2.84,1.65-2.81,3.8l.17,17.84a5,5,0,0,1-4.95,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M255.87,355.65a5,5,0,0,1-5-4.91l-.38-21a5,5,0,1,1,10-.19l.39,21a5,5,0,0,1-4.91,5.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M113.63,369.84a4.84,4.84,0,0,1-1.13-.13,5,5,0,0,1-3.75-6l4-17.37c.47-2.08-.35-3.93-1.92-4.29l-16.17-3.83a2.45,2.45,0,0,0-2,.44,4.21,4.21,0,0,0-1.61,2.59l-4,17.38a5,5,0,0,1-9.75-2.25l4-17.37a14.3,14.3,0,0,1,5.6-8.53,12.45,12.45,0,0,1,10-2l16.17,3.83c7,1.6,11.12,8.75,9.39,16.27l-4,17.39A5,5,0,0,1,113.63,369.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M89.22,443.57a45.55,45.55,0,1,1,24.35-7.14A45.4,45.4,0,0,1,89.22,443.57Zm-.1-81a35.56,35.56,0,0,0-34.65,27.82h0a35.47,35.47,0,1,0,34.65-27.82ZM49.59,389.28h0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M103.59,340.19a4.55,4.55,0,0,1-1.09-.12,5,5,0,0,1-3.8-6l4.55-20.5a5,5,0,0,1,9.76,2.16l-4.54,20.51A5,5,0,0,1,103.59,340.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M281.82,334.78c-32.42,0-63.08-1.89-89.67-4.43C110.34,322.53,48.39,307,47.77,306.85a5,5,0,0,1,2.46-9.7c.61.16,62,15.52,143,23.26,135.16,12.9,220.36-4.9,268-22.11a5,5,0,0,1,3.4,9.4C407.51,328.35,341.67,334.78,281.82,334.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M145.75,205.44a5,5,0,0,1-.05-10l19.1-.2h.06a5,5,0,0,1,0,10l-19.1.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M12.82,206.85a5,5,0,0,1-.06-10L30,196.64a5,5,0,1,1,.12,10l-17.24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M22.89,245.42a5,5,0,0,1-2.55-9.31l15.14-9a5,5,0,0,1,5.09,8.61l-15.13,8.95A5,5,0,0,1,22.89,245.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M51.08,273a5,5,0,0,1-4.35-7.46l9-15.91a5,5,0,0,1,8.72,4.91l-9,15.91A5,5,0,0,1,51.08,273Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M89.12,282.59a5,5,0,0,1-5-4.94l-.22-18.34a5,5,0,0,1,10-.12l.22,18.34a5,5,0,0,1-4.94,5.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M127.33,272.22a5,5,0,0,1-4.31-2.45l-9.6-16.24a5,5,0,1,1,8.61-5.09l9.6,16.24a5,5,0,0,1-1.76,6.84A4.9,4.9,0,0,1,127.33,272.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M154.93,244a5.06,5.06,0,0,1-2.45-.64l-16.56-9.33a5,5,0,0,1,4.91-8.71l16.56,9.32a5,5,0,0,1-2.46,9.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M12.82,207a5,5,0,0,1-.05-10l19.1-.21h.06a5,5,0,0,1,.05,10L12.87,207Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M147.62,205.55a5,5,0,0,1-.06-10l17.24-.21h.06a5,5,0,0,1,.06,10l-17.24.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M139.66,175.72a5,5,0,0,1-2.55-9.31l15.13-8.95a5,5,0,0,1,5.09,8.61l-15.13,9A5,5,0,0,1,139.66,175.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M39.3,177.49a5,5,0,0,1-2.45-.64l-16.56-9.33a5,5,0,1,1,4.9-8.71l16.56,9.32a5,5,0,0,1-2.45,9.36Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M89.34,193.89a5,5,0,0,1-5-5V162a5,5,0,0,1,10,0v26.89A5,5,0,0,1,89.34,193.89Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M314,180.43a5,5,0,0,1-.81-9.93L332,167.39a5,5,0,0,1,1.63,9.86l-18.85,3.12A5.76,5.76,0,0,1,314,180.43Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M182.78,202.09a5,5,0,0,1-.82-9.93l17-2.84a5,5,0,0,1,1.64,9.86l-17,2.84A4.73,4.73,0,0,1,182.78,202.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M198.62,238.67a5,5,0,0,1-3.17-8.86L209,218.65a5,5,0,1,1,6.34,7.73l-13.59,11.16A5,5,0,0,1,198.62,238.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M230.69,261.66A5,5,0,0,1,226,254.9l6.44-17.09a5,5,0,1,1,9.36,3.52l-6.44,17.09A5,5,0,0,1,230.69,261.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M269.74,265.32a5,5,0,0,1-4.93-4.18l-3-18.1a5,5,0,0,1,9.86-1.64l3,18.09a5,5,0,0,1-4.11,5.76A5.93,5.93,0,0,1,269.74,265.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M305.92,249.24a5,5,0,0,1-3.87-1.83l-12-14.58a5,5,0,0,1,7.73-6.34l12,14.58a5,5,0,0,1-3.86,8.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M328.91,217.16a4.93,4.93,0,0,1-1.76-.32l-17.79-6.69a5,5,0,1,1,3.52-9.36l17.79,6.69a5,5,0,0,1-1.76,9.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M182.8,202.19a5,5,0,0,1-.81-9.94l18.85-3.11a5,5,0,0,1,1.63,9.86l-18.85,3.12A5.79,5.79,0,0,1,182.8,202.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M315.81,180.26a5,5,0,0,1-.82-9.94l17-2.83a5,5,0,1,1,1.65,9.86l-17,2.84A5.67,5.67,0,0,1,315.81,180.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M303.4,152a5,5,0,0,1-3.18-8.87L313.81,132a5,5,0,1,1,6.35,7.73l-13.6,11.15A4.93,4.93,0,0,1,303.4,152Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M204.48,169a5,5,0,0,1-1.76-.32L184.93,162a5,5,0,0,1,3.52-9.36l17.79,6.7a5,5,0,0,1-1.76,9.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M256.43,177.62a5,5,0,0,1-4.94-4.24l-4.1-26.58a5,5,0,0,1,9.89-1.52l4.1,26.57a5,5,0,0,1-4.18,5.71A5.09,5.09,0,0,1,256.43,177.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M472.21,122.31a5,5,0,0,1-1.95-9.6l17.59-7.45a5,5,0,1,1,3.9,9.21l-17.59,7.45A5,5,0,0,1,472.21,122.31Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M349.77,174.11a5,5,0,0,1-1.95-9.6l15.86-6.75a5,5,0,1,1,3.91,9.21l-15.86,6.74A5,5,0,0,1,349.77,174.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M373.73,206a4.94,4.94,0,0,1-3-1,5,5,0,0,1-1-7l10.6-14a5,5,0,1,1,8,6l-10.6,14A5,5,0,0,1,373.73,206Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M410.32,220.79a4.21,4.21,0,0,1-.62,0,5,5,0,0,1-4.35-5.57l2.25-18.13a5,5,0,0,1,9.92,1.23l-2.25,18.13A5,5,0,0,1,410.32,220.79Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M449.13,215.19a5,5,0,0,1-4.6-3l-7.17-16.89a5,5,0,0,1,9.2-3.91l7.17,16.89a5,5,0,0,1-4.6,6.95Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M480.52,191.09a5,5,0,0,1-3-1l-15-11.37a5,5,0,1,1,6-8l15.05,11.37a5,5,0,0,1-3,9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M495.36,154.51a4.4,4.4,0,0,1-.62,0l-18.86-2.33a5,5,0,0,1,1.23-9.93L496,144.55a5,5,0,0,1-.61,10Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M349.81,174.2a5,5,0,0,1-1.95-9.6l17.6-7.45a5,5,0,0,1,3.89,9.21l-17.59,7.45A5.18,5.18,0,0,1,349.81,174.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M474,121.71a5,5,0,0,1-2-9.61l15.86-6.74a5,5,0,1,1,3.91,9.2l-15.86,6.74A4.84,4.84,0,0,1,474,121.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M455.27,97.13a4.92,4.92,0,0,1-3-1,5,5,0,0,1-1-7l10.59-14a5,5,0,1,1,8,6l-10.6,14A5,5,0,0,1,455.27,97.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M363.12,136.9c-.2,0-.41,0-.62,0l-18.86-2.34a5,5,0,0,1,1.23-9.93l18.86,2.34a5,5,0,0,1-.61,10Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M415.63,133.06A5,5,0,0,1,411,130l-10.22-24.88a5,5,0,0,1,9.25-3.8l10.22,24.88a5,5,0,0,1-2.73,6.52A4.88,4.88,0,0,1,415.63,133.06Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M351.42,419.14a5,5,0,0,1-.79-9.94l18.86-3.06a5,5,0,0,1,1.6,9.87l-18.86,3.06A4.43,4.43,0,0,1,351.42,419.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M484.49,397.53a5,5,0,0,1-.79-9.94l17-2.73a5,5,0,0,1,1.59,9.87l-17,2.73A4.29,4.29,0,0,1,484.49,397.53Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M498.17,434.52a5.09,5.09,0,0,1-1.78-.33L480,428a5,5,0,0,1,3.54-9.35l16.44,6.24a5,5,0,0,1-1.77,9.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M475.1,466.53a5,5,0,0,1-3.88-1.84l-11.55-14.15a5,5,0,0,1,7.75-6.32L479,458.37a5,5,0,0,1-3.87,8.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M439.24,482.44a5,5,0,0,1-4.93-4.2l-2.91-18.11a5,5,0,1,1,9.87-1.59l2.91,18.11a5,5,0,0,1-4.14,5.73A5.49,5.49,0,0,1,439.24,482.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M399.83,478.74a5,5,0,0,1-4.67-6.78l6.69-17.63a5,5,0,1,1,9.35,3.55l-6.69,17.63A5,5,0,0,1,399.83,478.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M367.82,455.66a5,5,0,0,1-3.16-8.87l14.72-12a5,5,0,1,1,6.33,7.75l-14.73,12A5,5,0,0,1,367.82,455.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M482.67,398a5,5,0,0,1-.8-9.93L500.73,385a5,5,0,1,1,1.6,9.87l-18.86,3.06A5.49,5.49,0,0,1,482.67,398Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M351.44,419.23a5,5,0,0,1-.79-9.93l17-2.73a5,5,0,0,1,1.58,9.87l-17,2.73A5.49,5.49,0,0,1,351.44,419.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M371.23,385.75a5,5,0,0,1-1.77-.32L353,379.19a5,5,0,0,1,3.54-9.35L373,376.08a5,5,0,0,1-1.77,9.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M470.42,370.38a5,5,0,0,1-3.17-8.87l14.73-12a5,5,0,1,1,6.32,7.74l-14.72,12A5,5,0,0,1,470.42,370.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M423.9,395.08a5,5,0,0,1-4.92-4.15l-4.58-26.5a5,5,0,1,1,9.85-1.7l4.58,26.49a5,5,0,0,1-4.07,5.78A5.1,5.1,0,0,1,423.9,395.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M181.18,420.27a5,5,0,0,1,0-10l19.1-.15h0a5,5,0,0,1,0,10l-19.11.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M316,419.19a5,5,0,0,1,0-10l17.24-.1h0a5,5,0,0,1,0,10l-17.24.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M323.86,457.84a5,5,0,0,1-2.46-.65l-15.3-8.67a5,5,0,0,1,4.94-8.7l15.29,8.67a5,5,0,0,1-2.47,9.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M296.18,486a5,5,0,0,1-4.31-2.47l-9.26-15.74a5,5,0,0,1,8.63-5.07l9.25,15.75a5,5,0,0,1-1.78,6.84A5,5,0,0,1,296.18,486Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M258.32,496.22a5,5,0,0,1-5-5l-.11-18.34a5,5,0,0,1,10-.06l.11,18.34a5,5,0,0,1-5,5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M219.93,486.55a5,5,0,0,1-4.34-7.47l9.3-16.4a5,5,0,0,1,8.7,4.93L224.29,484A5,5,0,0,1,219.93,486.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M191.82,458.86a5,5,0,0,1-2.54-9.31l16.39-9.63a5,5,0,0,1,5.06,8.62l-16.38,9.63A5,5,0,0,1,191.82,458.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M314.12,419.34a5,5,0,0,1,0-10l19.11-.15h0a5,5,0,0,1,0,10l-19.11.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M181.19,420.37a5,5,0,0,1,0-10l17.24-.11h0a5,5,0,0,1,0,10l-17.24.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M205.84,390.29a5,5,0,0,1-2.46-.65L188.08,381a5,5,0,0,1,4.93-8.7l15.3,8.67a5,5,0,0,1-2.47,9.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M306.22,390.22a5,5,0,0,1-2.54-9.31l16.38-9.63a5,5,0,1,1,5.07,8.62l-16.38,9.63A5,5,0,0,1,306.22,390.22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M256.48,407.54a5,5,0,0,1-5-4.91L251,375.74a5,5,0,0,1,10-.18l.49,26.88a5,5,0,0,1-4.9,5.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M34.44,389.84a4.9,4.9,0,0,1-1.13-.13L14.7,385.37A5,5,0,1,1,17,375.63L35.57,380a5,5,0,0,1-1.13,9.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M163.92,420a5.07,5.07,0,0,1-1.15-.13L146,415.93a5,5,0,0,1,2.28-9.74l16.79,3.94a5,5,0,0,1-1.14,9.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M145.73,455.47a5,5,0,0,1-3.42-1.35l-12.83-12a5,5,0,0,1,6.83-7.3l12.84,12a5,5,0,0,1-3.42,8.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M112.22,476.32a5,5,0,0,1-4.78-3.55l-5.31-17.47a5,5,0,0,1,9.57-2.91L117,469.87a5,5,0,0,1-4.79,6.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M73,477.42a5,5,0,0,1-4.87-6.14l4.19-17.86a5,5,0,1,1,9.73,2.28l-4.18,17.86A5,5,0,0,1,73,477.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M38,459a5,5,0,0,1-3.65-8.41l12.89-13.77a5,5,0,0,1,7.3,6.83L41.62,457.44A5,5,0,0,1,38,459Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M17.12,425.52a5,5,0,0,1-1.45-9.79l18.18-5.52a5,5,0,0,1,2.91,9.57L18.57,425.3A4.86,4.86,0,0,1,17.12,425.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M163.9,420.1a4.94,4.94,0,0,1-1.14-.14l-18.61-4.33a5,5,0,0,1,2.27-9.74L165,410.23a5,5,0,0,1-1.13,9.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M32.6,389.54a5.07,5.07,0,0,1-1.15-.13l-16.78-3.94A5,5,0,1,1,17,375.73l16.79,3.94a5,5,0,0,1-1.14,9.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M46.83,362.14a5,5,0,0,1-3.42-1.35l-12.83-12a5,5,0,1,1,6.83-7.29l12.84,12a5,5,0,0,1-3.42,8.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M144.42,385.61a5,5,0,0,1-1.45-9.79l18.18-5.52a5,5,0,0,1,2.91,9.57l-18.19,5.52A4.86,4.86,0,0,1,144.42,385.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "lights-icon",
  d: "M92,390.78a5,5,0,0,1-4.88-6.09L93,358.44a5,5,0,0,1,9.76,2.17L96.9,386.86A5,5,0,0,1,92,390.78Z"
}));

function SvgLights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLights);
export default __webpack_public_path__ + "static/media/lights.033fc9b4.svg";
export { ForwardRef as ReactComponent };